__turbopack_context__.v({
  "description": "ratesTable-module-scss-module__bmxozq__description",
  "disclaimer": "ratesTable-module-scss-module__bmxozq__disclaimer",
  "title": "ratesTable-module-scss-module__bmxozq__title",
});
